import { render, staticRenderFns } from "./BaseTransactionDetailsShoppingRefund.vue?vue&type=template&id=19bb5d70&"
import script from "./BaseTransactionDetailsShoppingRefund.vue?vue&type=script&lang=js&"
export * from "./BaseTransactionDetailsShoppingRefund.vue?vue&type=script&lang=js&"
import style0 from "./BaseTransactionDetailsShoppingRefund.vue?vue&type=style&index=0&id=19bb5d70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports